import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { FakeLink } from "../../link/src";
import { Pill } from "../../pill/src";
export const PillsList = ({ ExternalComponent, dataTestId, pills, seeLessLabel, seeMoreLabel, }) => {
    const [shouldRenderSeeMore, setShouldRenderSeeMore] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [pillsToRender, setPillsToRender] = useState([]);
    const firstPillMarginLeft = ExternalComponent ? 2 : 0;
    const seeMoreOrLessLabel = useMemo(() => (isCollapsed ? seeMoreLabel : seeLessLabel), [isCollapsed, seeLessLabel, seeMoreLabel]);
    const handleToggleShowPills = useCallback(() => {
        if (isCollapsed) {
            setPillsToRender(pills);
            setIsCollapsed(false);
        }
        else {
            setPillsToRender(pills.slice(0, 4));
            setIsCollapsed(true);
        }
    }, [isCollapsed, pills]);
    useEffect(() => {
        if ((pills === null || pills === void 0 ? void 0 : pills.length) > 4) {
            setShouldRenderSeeMore(true);
            setPillsToRender(pills.slice(0, 4));
        }
        else {
            setPillsToRender(pills);
        }
    }, [pills]);
    if (!pills || (pills === null || pills === void 0 ? void 0 : pills.length) === 0) {
        return null;
    }
    if ((pillsToRender === null || pillsToRender === void 0 ? void 0 : pillsToRender.length) === 0) {
        return _jsx(Box, { height: "32px" });
    }
    return (_jsxs(Box, { alignItems: "center", "data-testid": dataTestId, flexWrap: "wrap", children: [ExternalComponent, pillsToRender === null || pillsToRender === void 0 ? void 0 : pillsToRender.map((pill, index) => (_jsx(PillWrapper, { ml: index === 0 ? firstPillMarginLeft : 0, mr: index === (pillsToRender === null || pillsToRender === void 0 ? void 0 : pillsToRender.length) - 1
                    ? shouldRenderSeeMore
                        ? 2
                        : 0
                    : 2, children: _jsx(Pill, { href: pill.href, onClick: pill.onClick, children: pill.name }) }, pill.id || index))), shouldRenderSeeMore && (_jsx(FakeLink, { mb: "2px", onClick: handleToggleShowPills, onKeyDown: onEnterOrSpacePress(handleToggleShowPills), children: seeMoreOrLessLabel }))] }));
};
const PillWrapper = styled(Box).attrs(() => ({
    my: 1,
})) `
  word-break: break-word;
`;
//# sourceMappingURL=PillsList.js.map